import { Container, Row, Col, Placeholder } from "react-bootstrap";
import classes from "./MainInvoice.module.scss";
import { TextField } from "../form/TextField";
import { BoolField } from "../form/BoolField";
import { DateField } from "../form/DateField";
import { GenericTooltip } from "../form/GenericTooltip";
import { NumberField } from "../form/NumberField";
import { SelectField } from "../form/SelectField";
import { DateTimeField } from "../form/DateTimeField";
import { useContext } from "react";
import { OrgIdContext } from "../../../store/orgId_context";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Button from "../../UI/Button";
//import QRCode from "react-qr-code";


//const urlAppend = "https://dev.dddinvoices.com/";

const urlAppend = process.env.REACT_APP_ORIGIN_SLASH || "";
const MainInvoice = ({loading, fieldInfo:data, onFieldChange, mandatoryOnly, onAddDetail, onRemoveDetail, onConfirm}) =>{console.log(data);
    const { isMaintainer, sessionInfo } = useContext(OrgIdContext);
    let fillerText = "Generated";
    const handleFieldChange = (value, fieldName, objData) =>{
        if(onFieldChange)
            onFieldChange(fieldName, value, objData)
    }

    const getFieldInput = (fieldName, config, detail, detailIndex) =>{
        let fieldConfig = config;
        if(!config){
            if(!data.hasOwnProperty(fieldName)) return null;
            fieldConfig = data[fieldName];
        }
        
        const { Type, Trans, ValidValues } = fieldConfig;

        if(Type?.toLowerCase() === "string" && !ValidValues)
            return <TextField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></TextField>
        if(Type?.toLowerCase() === "number")
            return <NumberField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></NumberField>
        if(Type?.toLowerCase() === "bool")
            return <BoolField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></BoolField>
        if(ValidValues && ValidValues.length > 0)
            return <SelectField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></SelectField>
        if(Type?.toLowerCase() === "date")
            return <DateField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></DateField>
        if(Type?.toLowerCase() === "datetime")
            return <DateTimeField className={classes["inputs"]} fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></DateTimeField>

        return <TextField fieldConfig={fieldConfig} fieldName={fieldName} onChange={handleFieldChange} detail={detail} index={detailIndex} disabled={!fieldConfig?.Mandatory&&mandatoryOnly}></TextField>

    }

    const onRemoveClick = (detail,index, total) =>{
        if(!total || total.length<2) return;
        if(onRemoveDetail)
            onRemoveDetail(detail,index);
    }

    const onAddClick = (detail) => {
        if(onAddDetail)
            onAddDetail(detail);
    }
    return (<>
    <div style={{padding:"1rem", marginTop:"1rem"}}>
        <Row>
            <div className="d-flex">
                <div>
                    <span>{data?.DocTypeCode?.Trans?.Title||"Document type"}:</span>
                    {getFieldInput("DocTypeCode")}
                </div>
                <div className="ms-2">
                    <span>{data?.DocSaleTypeCode?.Trans?.Title||"Sale type"}:</span>
                    {getFieldInput("DocSaleTypeCode")}
                </div>
                <div className="ms-2">
                    <span>{data?.DocPaymentTypeCode?.Trans?.Title||"Payment type"}:</span>
                    {getFieldInput("DocPaymentTypeCode")}
                </div>
            </div>
        </Row>
        <Row className="mt-4">
            <Col style={{textAlign:"center"}} className={`col-12 col-md-4 order-md-2`}>
                <div>{data?.SellerLogo?.Value && <img className={classes["img-thumbnail-logo"]} src={urlAppend+data?.SellerLogo?.Value}/>}</div>
                <div>{data?.SellerTelephone?.Value}</div>
                <div>{data?.SellerEmail?.Value}</div>
            </Col>
            <Col className={`col-12 col-md-4 order-md-1`}>
                <h6>Invoice issuer</h6>
                <p style={{textAlign:"left"}}>
                    <span style={{display:"block", fontWeight:"700"}}>{sessionInfo?.Organization?.Title}</span>
                    <span style={{display:"block"}}>{data?.SellerAddres?.Trans?.Title||"Address"}: {fillerText}</span>
                    <span style={{display:"block"}}>{data?.SellerCityName?.Trans?.Title||"City"} :{fillerText}</span>
                    <span style={{display:"block"}}>{data?.SellerPostCode?.Trans?.Title||"Post code"}: {fillerText}</span>
                    <span style={{display:"block"}}>{data?.SellerTaxNum?.Trans?.Title||"Tax number"}: {sessionInfo?.Organization?.TaxNo||fillerText}</span>
                    <span style={{display:"block"}}>{data?.SellerRegNum?.Trans?.Title||"Registration number"}: {sessionInfo?.Organization?.RegNum||fillerText}</span>
                    <span style={{display:"block"}}>{data?.SellerVatNum?.Trans?.Title||"Vat number"}: {sessionInfo?.Organization?.VatNo||fillerText}</span>
                </p>
            </Col>
            
            <Col className={`col-12 col-md-4 order-md-3`}>
                <h6>Buyer</h6>
                {/* <p style={{textAlign:"left"}}>
                    <span style={{display:"block", fontWeight:"bolder"}}>{data?.BuyerName?.Trans?.Title||"Buyer name"}: {getFieldInput("BuyerName")}</span>
                    <span style={{display:"block"}}>{data?.BuyerStreet?.Trans?.Title||"Street"}: {getFieldInput("BuyerStreet")}</span>
                    <span style={{display:"block"}}>{data?.BuyerPostCode?.Trans?.Title||"Post code"}: {getFieldInput("BuyerPostCode")}</span>
                    <span style={{display:"block"}}>{data?.BuyerCity?.Trans?.Title||"City"}: {getFieldInput("BuyerCity")}</span>
                    <span style={{display:"block"}}>{data?.BuyerTaxNum?.Trans?.Title||"Tax number"}: {getFieldInput("BuyerTaxNum")}</span>
                    <span style={{display:"block"}}>{data?.BuyerVatNum?.Trans?.Title||"Vat number"}: {getFieldInput("BuyerVatNum")}</span>
                </p> */}
                <table>
                    <tbody>
                        <tr>
                            <td>{data?.BuyerName?.Trans?.Title||"Buyer name"}:</td>
                            <td>{getFieldInput("BuyerName")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerStreet?.Trans?.Title||"Street"}:</td>
                            <td>{getFieldInput("BuyerStreet")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerPostCode?.Trans?.Title||"Post code"}:</td>
                            <td>{getFieldInput("BuyerPostCode")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerCountryCode?.Trans?.Title||"Country code"}:</td>
                            <td>{getFieldInput("BuyerCountryCode")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerCity?.Trans?.Title||"City"}:</td>
                            <td>{getFieldInput("BuyerCity")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerTaxNum?.Trans?.Title||"Tax number"}:</td>
                            <td>{getFieldInput("BuyerTaxNum")}</td>
                        </tr>
                        <tr>
                            <td>{data?.BuyerVatNum?.Trans?.Title||"Vat number"}:</td>
                            <td>{getFieldInput("BuyerVatNum")}</td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </Row>
        <Row>
            <Col>
                <span style={{display:"block", backgroundColor:"#315e90de", color:"white", padding:"8px"}}>Invoice: {getFieldInput("DocNumber")||fillerText}</span>
            </Col>
        </Row>
        <Row>
            <Col style={{textAlign:"center"}} className={`col-12 col-md-4 order-md-2`}>
                {/* {data?.FiscQRContent?.Value && <QRCode className={classes["id-bill-qr"]} value={data?.FiscQRContent?.Value}/>} */}
            </Col>
            <Col className={`col-12 col-md-4 order-md-1`}>
            <table>
                <tbody>
                <tr>
                    <td className={classes["table-title-td"]}>{data?.DocIssuePlace?.Trans?.Title||"Place of issue"}:</td>
                    <td>{getFieldInput("DocIssuePlace")||fillerText}</td>
                </tr>
                <tr>
                    <td className={classes["table-title-td"]}>{data?.DocIssueDate?.Trans?.Title||"Invoice date"}:</td>
                    <td>{getFieldInput("DocIssueDate")||fillerText}</td>
                </tr>
                <tr>
                    <td className={classes["table-title-td"]}>Delivery date:</td>
                    <td>
                        {getFieldInput("DocStartDate")||fillerText}
                        -
                        {getFieldInput("DocEndDate")||fillerText}
                    </td>
                </tr>
                <tr>
                    <td className={classes["table-title-td"]}>{data?.DocDueDate?.Trans?.Title||"Due date"}:</td>
                    <td> {getFieldInput("DocDueDate")||fillerText}</td>
                </tr>
                <tr>
                    <td className={classes["table-title-td"]}>{data?.DocBuyerOrderRef?.Trans?.Title||"Order"}:</td>
                    <td>{getFieldInput("DocBuyerOrderRef")||fillerText}</td>
                </tr>
                </tbody>
            </table>
            </Col>
            <Col className={`col-12 col-md-4 order-md-3`} >
                {data?.FiscMoment?.Value && <>
                <div>
                    <span style={{fontWeight:"500", textWrap:"nowrap"}}>{data?.FiscCalcNum?.Trans?.Title||"ZOI"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscCalcNum?.LocalizedValue||data?.FiscCalcNum?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.FiscTANum?.Trans?.Title||"EOR"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscTANum?.LocalizedValue||data?.FiscTANum?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.FiscInvNumber?.Trans?.Title||"Invoice num."}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscInvNumber?.LocalizedValue||data?.FiscInvNumber?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.FiscSerialNum?.Trans?.Title||"Invoice serial"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscSerialNum?.LocalizedValue||data?.FiscSerialNum?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.FiscMoment?.Trans?.Title||"Fiscalization time"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscMoment?.LocalizedValue||data?.FiscMoment?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.FiscDeviceRegCode?.Trans?.Title||"Device"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.FiscDeviceRegCode?.LocalizedValue||data?.FiscDeviceRegCode?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.OperatorFISCRegistration?.Trans?.Title||"Operator"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.OperatorFISCRegistration?.LocalizedValue||data?.OperatorFISCRegistration?.Value}</span>
                </div>
                <div>
                    <span style={{fontWeight:"500"}}>{data?.Mode?.Trans?.Title||"Mode"}:</span>
                    <span style={{overflowWrap:"break-word"}}>{data?.Mode?.LocalizedValue||data?.Mode?.Value}</span>
                </div>
                </>}
                {/* <table>
                    <tbody>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscCalcNum?.Trans?.Title||"ZOI"}:</td>
                        <td>{data?.FiscCalcNum?.LocalizedValue||data?.FiscCalcNum?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscTANum?.Trans?.Title||"EOR"}:</td>
                        <td>{data?.FiscTANum?.LocalizedValue||data?.FiscTANum?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscInvNumber?.Trans?.Title||"Invoice num."}:</td>
                        <td>{data?.FiscInvNumber?.LocalizedValue||data?.FiscInvNumber?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscSerialNum?.Trans?.Title||"Invoice serial"}:</td>
                        <td>{data?.FiscSerialNum?.LocalizedValue||data?.FiscSerialNum?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscMoment?.Trans?.Title||"Fiscalization time"}:</td>
                        <td>{data?.FiscMoment?.LocalizedValue||data?.FiscMoment?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.FiscDeviceRegCode?.Trans?.Title||"Device"}:</td>
                        <td>{data?.FiscDeviceRegCode?.LocalizedValue||data?.FiscDeviceRegCode?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.OperatorFISCRegistration?.Trans?.Title||"Operator"}:</td>
                        <td>{data?.OperatorFISCRegistration?.LocalizedValue||data?.OperatorFISCRegistration?.Value}</td>
                    </tr>
                    <tr>
                        <td className={classes["table-title-td"]}>{data?.Mode?.Trans?.Title||"Mode"}:</td>
                        <td>{data?.Mode?.LocalizedValue||data?.Mode?.Value}</td>
                    </tr>
                    </tbody>
                </table> */}
            </Col>
        </Row>
        <Row style={{marginTop:"2rem"}} > 
            <Col>
                <table className={classes["table-items"]}>
                    <thead>
                        <tr className={classes["table-title-tr"]}>
                            <th style={{width:"auto", minWidth:"200px"}}>Item title</th>
                            <th style={{width:"5%", textAlign:"right"}}>Qty</th>
                            <th style={{width:"3%", textAlign:"right"}}>UM</th>
                            <th style={{width:"5%", textAlign:"right"}}>Unit price without VAT</th>
                            <th style={{width:"4%", textAlign:"right"}}>% Discount</th>
                            <th style={{width:"5%", textAlign:"right"}}>% VAT</th>
                            <th style={{width:"6%", textAlign:"right"}}>Unit price with VAT</th>
                            <th style={{width:"5%", textAlign:"right"}}>Amount without VAT</th>
                            <th style={{width:"5%", textAlign:"right"}}>VAT amount</th>
                            <th style={{width:"7%", textAlign:"right"}}>Amount with VAT</th>
                        </tr>
                    </thead>
                    <tbody style={{fontSize:"0.8rem"}}>
                        {data?._details?.Items && data._details.Items.map((item,index) => {
                            return(<>
                                <tr className={classes["table-tr"]}>
                                    <td style={{textAlign:"left"}}>{getFieldInput("ItemName", item?.ItemName, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("ItemQuantity", item?.ItemQuantity, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("ItemUmcCode", item?.ItemUmcCode, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("ItemNetPrice", item?.ItemNetPrice, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("ItemAllowancePercent", item?.ItemAllowancePercent, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("ItemVatCode", item?.ItemVatCode, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("RetailPrice", item?.RetailPrice, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("NetAmount", item?.NetAmount, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("VatAmount", item?.VatAmount, "Items", index)||fillerText}</td>
                                    <td>{getFieldInput("NetAmountIncludingVat", item?.NetAmountIncludingVat, "Items", index)||fillerText}</td>
                                    <td onClick={() => onRemoveClick("Items", index, data._details.Items)} style={{maxWidth:"0.4rem"}}><RemoveIcon className={classes["add-remove"]}  style={{backgroundColor:"red", fontSize:"1rem"}}/></td>
                                </tr>
                            </>)
                        })}
                        {/* {data?._details?.Items && data._details.Items.map(item => {
                            return(<>
                                <tr className={classes["table-tr"]}>
                                    <td style={{textAlign:"left"}}>{item?.ItemName?.Value}</td>
                                    <td>{item?.ItemQuantity?.Value}</td>
                                    <td>{item?.ItemUmcCode?.Value}</td>
                                    <td>{item?.ItemNetPrice?.LocalizedValue||item?.ItemNetPrice?.Value}</td>
                                    <td>{item?.ItemAllowancePercent?.Value}</td>
                                    <td>{item?.ItemVatCode?.Value}</td>
                                    <td>{item?.RetailPrice?.LocalizedValue||item?.RetailPrice?.Value}</td>
                                    <td>{item?.NetAmount?.LocalizedValue||item?.NetAmount?.Value}</td>
                                    <td>{item?.VatAmount?.LocalizedValue||item?.VatAmount?.Value}</td>
                                    <td>{item?.NetAmountIncludingVat?.LocalizedValue||item?.NetAmountIncludingVat?.Value}</td>
                                </tr>
                            </>)
                        })} */}
                        <tr>
                            <td colSpan={10}>
                                <div style={{textAlign:"right"}}>
                                <AddIcon onClick={() => onAddClick("Items")} className={classes["add-remove"]} style={{backgroundColor:"green", fontSize:"1rem"}}/>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </Row>
        <Row style={{marginTop:"2rem"}}>
            <Col className="col-12 col-md-6">
                <table style={{fontSize:".8rem", width:"100%"}}>
                    <thead>
                        <tr className={classes["vats-table-tr-title"]}>
                            <th>Tax rate %	</th>
                            <th>No. of items</th>
                            <th>Taxable amt.</th>
                            <th>Tax amt.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?._details?.EU_Invoices_VatsUI && data._details.EU_Invoices_VatsUI.map(item => {
                            return (<tr className={classes["vats-table-tr"]}>
                                <td>{item?.TaxRate?.Value}</td>
                                <td>{item?.NoOfItems?.Value}</td>
                                <td>{item?.TaxableAmount?.LocalizedValue||item?.TaxableAmount?.Value}</td>
                                <td>{item?.TaxAmount?.LocalizedValue||item?.TaxAmount?.Value}</td>
                            </tr>)
                        })}
                    </tbody>
                </table>
            </Col>
            <Col className="col-1"></Col>
            <Col className="col-12 col-md-5">
                <p style={{marginBottom:"0.2rem"}}>
                    <span style={{marginBottom:"0.25rem", paddingBottom:"0.25rem", display:"block", borderBottom:"1px solid grey"}}>
                        <span>
                            <strong>
                                Subtotal
                            </strong>
                        </span>
                        <span style={{float:"right"}}>{getFieldInput("DocTotalAmountWithVAT")||fillerText}</span>
                    </span>
                    <FloatingSpan title={data?.DocTotalAmountWithoutVAT?.Trans?.Title||"Total amount without VAT"} value={getFieldInput("DocTotalAmountWithoutVAT")||fillerText}/>
                    <FloatingSpan title={data?.DocTotalVatAmountCC?.Trans?.Title||"Total VAT amount"} value={getFieldInput("DocTotalVatAmountCC")||fillerText}/>
                    <FloatingSpan title={data?.DocTotalAmount?.Trans?.Title||"Total amount with VAT"} value={getFieldInput("DocTotalAmount")||fillerText}/>
                    <span style={{marginBottom:"0.25rem",  display:"block", color:"white", backgroundColor:"#315e90de"}}>
                        <span>
                            <strong>Total({getFieldInput("DocCurrencyCode")||fillerText})</strong>
                        </span>
                        <span style={{float:"right"}}><strong>{getFieldInput("DocTotal")||fillerText}</strong></span>
                    </span>
                    <span style={{marginBottom:"0.25rem",  display:"block", fontSize:"0.8rem"}}>
                        <span style={{paddingRight:"5px"}}><strong>{data?.DocCurrencyCode?.Trans?.Title||"Currency"}</strong></span>
                        <span style={{paddingRight:"5px"}}>{data?.DocCurrencyCode?.Value}</span>
                        <span style={{paddingRight:"5px"}}><strong>{data?.DocExchangeRate?.Trans?.Title||"Exchange rate"}</strong></span>
                        <span style={{paddingRight:"5px"}}>{getFieldInput("DocExchangeRate")||fillerText}</span>
                    </span>
                </p>
            </Col>
        </Row>
        <Row style={{marginTop:"2rem"}}>
            <Col className="col-12 col-md-4"></Col>
            <Col className="col-12 col-md-1"></Col>
            <Col className="col-12 col-md-7">
            <table style={{fontSize:".8rem", width:"100%"}}>
                    <thead>
                        <tr className={classes["vats-table-tr-title"]}>
                            <th>Payment type</th>
                            <th>Account type</th>
                            <th>Pay number</th>
                            <th>Network provider</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?._details?.Payments && data._details.Payments.map((item,index) => {
                            return(<>
                                <tr className={classes["table-tr"]}>
                                    <td>{getFieldInput("PayCode", item?.PayCode, "Payments", index)||fillerText}</td>
                                    <td>{getFieldInput("PayPayeeAccountType", item?.PayPayeeAccountType, "Payments", index)||fillerText}</td>
                                    <td>{getFieldInput("PayNumber", item?.PayNumber, "Payments", index)||fillerText}</td>
                                    <td>{getFieldInput("PayNetworkProvider", item?.PayNetworkProvider, "Payments", index)||fillerText}</td>
                                    <td>{getFieldInput("PayAmount", item?.PayAmount, "Payments", index)||fillerText}</td>
                                    <td onClick={() => onRemoveClick("Payments", index, data._details.Payments)}><RemoveIcon className={classes["add-remove"]}  style={{backgroundColor:"red", fontSize:"1rem"}}/></td>
                                </tr>
                            </>)
                        })}
                        <tr>
                            <td colSpan={5}>
                                <div style={{textAlign:"right"}}>
                                <AddIcon onClick={() => onAddClick("Payments")} className={classes["add-remove"]} style={{backgroundColor:"green", fontSize:"1rem"}}/>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </Row>
        <Row style={{marginTop:"2rem", fontSize:"0.8rem"}}>
            <Col>
                <span>{data?.DocIssuer?.Trans?.Title||"Invoiced by"}: {getFieldInput("DocIssuer")||fillerText}</span>
            </Col>
            <Col>
                <span>{data?.DocSigner?.Trans?.Title||"Responsible person"}: {getFieldInput("DocSigner")||fillerText}</span>
            </Col>
            <Col style={{textAlign:"right", marginRight:"2rem"}}>
                <span style={{textDecoration:"underline"}}>Received by:</span>
            </Col>
        </Row>
        <Row style={{marginTop:"2rem"}}>
            <Col style={{textAlign:"center"}}>
                {data?.SellerLogo?.Value && <img className={classes["img-thumbnail-logo"]} src={urlAppend+data?.SellerStamp?.Value}/>}
                {data?.SellerLogo?.Value && <img className={classes["img-thumbnail-logo"]} src={urlAppend+data?.SellerSignScan?.Value}/>}
            </Col>
        </Row>

        <div className="text-center pt-2" style={{borderTop:"1px solid"}}>
            <Button onClick={onConfirm}>Confirm</Button>
        </div>
    </div>
    </>);
}


const PlaceholderSpan = (props) =>{
    return(<Placeholder as="span" animation="glow">
        <Placeholder  {...props} />
    </Placeholder>)
}

const FloatingSpan = ({title, value}) =>{
    return(
        <span style={{marginBottom:"0.25rem",  display:"block"}}>
            <span>
                {title}
            </span>
            <span style={{float:"right"}}>{value}</span>
        </span>
    )
}
export default MainInvoice;